export default __webpack_public_path__ + "static/media/jh.3e1181cb.svg";